export const searchColumns = [
  { keyName: "created" },
  { keyName: "expired" },
  { keyName: "message" },
  { keyName: "messageType" },
  { keyName: "sender" }
];

export const sortColumns = [
  { keyName: "created" },
  { keyName: "expired" },
  { keyName: "message" },
  { keyName: "messageType" },
  { keyName: "sender" }
];



// WEBPACK FOOTER //
// ./src/components/Notifications/List/searchColumns.js